export var AutoRoutingDeclineReason;
(function (AutoRoutingDeclineReason) {
    AutoRoutingDeclineReason[AutoRoutingDeclineReason["AGENT"] = 10] = "AGENT";
    AutoRoutingDeclineReason[AutoRoutingDeclineReason["TIMEOUT"] = 20] = "TIMEOUT";
})(AutoRoutingDeclineReason || (AutoRoutingDeclineReason = {}));
//# sourceMappingURL=index.js.map